import {
    LegalDocumentView,
} from '@fondationcss/ui';
import { translate } from '@fondationcss/sdk';
import AppLayout from '@/app-layout.vue';

// Nom propre du produit : même texte dans toutes les langues.
const APP_NAME = 'Perspective'; // i18n-ignore: nom propre du produit, jamais traduit

// Les titres sont des getters paresseux : translate() est évalué à la navigation, dans la
// langue en vigueur, et non au chargement du module.
export const getCustomRoutes = () => [
    {
      // Formulaire d'admission PUBLIC — page autonome, hors chrome authentifié
      // (pas de DefaultLayout), accessible sans connexion.
      path: '/inscription',
      name: 'public-admission',
      component: () => import('@/views/public/admission-form.vue'),
      meta: { get title() { return translate('perspective.shell.route.admission'); } }
    },
    {
      // Documents légaux PUBLICS (Loi 25) — pages autonomes rendues par la
      // Fondation à partir des endpoints anonymes /api/Privacy/*.
      path: '/confidentialite',
      name: 'confidentialite',
      component: LegalDocumentView,
      props: { type: 'PrivacyPolicy' },
      meta: { get title() { return translate('perspective.shell.route.privacyPolicy'); } }
    },
    {
      path: '/avis-de-collecte',
      name: 'avis-de-collecte',
      component: LegalDocumentView,
      props: { type: 'PrivacyNotice' },
      meta: { get title() { return translate('perspective.shell.route.privacyNotice'); } }
    },
    {
      path: '/',
      component: AppLayout,
      meta: { title: APP_NAME },
      children: [
        {
          name: 'default-view',
          path: '',
          component: () => import('@/views/default-view.vue')
        },
        {
          name: 'docs',
          path: '/docs/:pathMatch(.*)',
          component: () => import('@/views/documentation.vue'),
          meta: { get title() { return translate('perspective.shell.route.documentation'); } }
        },
      ]
    },
    {
      path: '/parcours/',
      component: AppLayout,
      meta: { title: APP_NAME },
      children: [
        {
          name: 'parcours-eleve',
          path: 'eleve',
          component: () => import('@/views/parcours/eleve.vue'),
          meta: { get title() { return translate('perspective.shell.route.parcoursStudent'); } }
        },
        {
          name: 'parcours-eleve-detail',
          path: 'eleve/:id',
          component: () => import('@/views/parcours/eleve-detail.vue'),
          meta: { get title() { return translate('perspective.shell.route.parcoursStudent'); } }
        },
        {
          name: 'parcours-enseignant',
          path: 'enseignant',
          component: () => import('@/views/parcours/enseignant.vue'),
          meta: { get title() { return translate('perspective.shell.route.parcoursTeacher'); } }
        },
        {
          name: 'parcours-planification',
          path: 'planification',
          component: () => import('@/views/parcours/planification.vue'),
          meta: { get title() { return translate('perspective.shell.nav.planning'); } }
        },
        {
          name: 'parcours-gestion',
          path: 'gestion',
          component: () => import('@/views/parcours/gestion.vue'),
          meta: { get title() { return translate('perspective.shell.nav.management'); } }
        }
      ]
    },
    {
      path: '/lignedetemps/',
      component: AppLayout,
      meta: { title: APP_NAME },
      children: [
        {
          // L'élève y voit ses propres cours en cours ; le personnel y ouvre le tableau d'un élève.
          name: 'timeline-dashboard',
          path: 'tableau-de-bord',
          component: () => import('@/views/timeline/dashboard.vue'),
          meta: { get title() { return translate('perspective.shell.nav.dashboard'); } }
        },
        {
          name: 'timeline-dashboard-user',
          path: 'tableau-de-bord/:userId',
          component: () => import('@/views/timeline/dashboard.vue'),
          meta: { get title() { return translate('perspective.shell.nav.dashboard'); } }
        },
        {
          name: 'timeline-select',
          path: 'visualisateur',
          component: () => import('@/views/timeline/select.vue')
        },
        {
          name: 'timeline-select-with-user',
          path: 'visualisateur/:userId',
          component: () => import('@/views/timeline/select.vue')
        },
        {
          name: 'timeline-view',
          path: 'visualisateur/:userId/:timelineId',
          component: () => import('@/views/timeline/view.vue')
        },
        {
          name: 'timeline-settings2',
          path: 'parametres2',
          component: () => import('@/views/timeline/settings2.vue')
        }
      ]
    },
    {
      path: '/admin/',
      component: AppLayout,
      meta: { title: APP_NAME },
      children: [
        {
          name: 'import-export',
          path: 'import-export',
          component: () => import('@/views/import-export.vue')
        },
        {
          // Espace des rapports PDF. Le bouton « Imprimer en PDF » de l'éditeur de calendrier
          // Fondation y mène avec ?type=calendar&calendarId=…&calendarYearId=… (config
          // CalendarReportRoute dans main.ts).
          name: 'admin-rapports',
          path: 'rapports',
          component: () => import('@/views/rapports.vue'),
          meta: { get title() { return translate('perspective.shell.nav.reports'); } }
        },
        {
          // Centres (M1b-1): the shared SiteManagement from @byrnu/agora-shared.
          name: 'admin-centres',
          path: 'centres',
          component: () => import('@/views/admin/centres.vue'),
          meta: { get title() { return translate('perspective.shell.nav.centres'); } }
        },
        {
          // Enseignants (M1b-2): the shared TeacherManagement, and a record page per teacher.
          name: 'admin-enseignants',
          path: 'enseignants',
          // i18n-ignore-next-line: component module path, not text
          component: () => import('@/views/admin/enseignants.vue'),
          meta: { get title() { return translate('perspective.shell.nav.teachers'); } }
        },
        {
          name: 'admin-enseignant',
          // i18n-ignore-next-line: route path pattern, not text
          path: 'enseignants/:id',
          // i18n-ignore-next-line: component module path, not text
          component: () => import('@/views/admin/enseignant.vue'),
          meta: { get title() { return translate('perspective.shell.route.teacher'); } }
        },
        {
          name: 'admin-systeme-inscription',
          path: 'systeme/inscription',
          component: () => import('@/views/admin/systeme/inscription.vue'),
          meta: { get title() { return translate('perspective.shell.nav.admissionRequests'); } }
        },
        {
          name: 'admin-systeme-inscription-config',
          path: 'systeme/inscription-config',
          component: () => import('@/views/admin/systeme/inscription-config.vue'),
          meta: { get title() { return translate('perspective.shell.nav.enrollment'); } }
        },
        {
          name: 'admin-systeme-inscription-detail',
          path: 'systeme/inscription/:id',
          component: () => import('@/views/admin/systeme/inscription-detail.vue'),
          meta: { get title() { return translate('perspective.shell.route.admission'); } }
        },
        {
          name: 'admin-systeme-fga-frequentation',
          path: 'systeme/fga-frequentation',
          component: () => import('@/views/admin/systeme/fga-frequentation.vue'),
          meta: { get title() { return translate('perspective.shell.nav.fgaAttendance'); } }
        },
        {
          name: 'admin-systeme-fga-frequentation-detail',
          path: 'systeme/fga-frequentation/:id',
          component: () => import('@/views/admin/systeme/fga-frequentation-detail.vue'),
          meta: { get title() { return translate('perspective.shell.route.fgaAttendanceDetail'); } }
        },
        {
          // Confidentialité (Loi 25) — paramètres de l'organisation, documents
          // légaux et politique de conservation, montés depuis @fondationcss/ui.
          name: 'admin-systeme-privacy',
          path: 'systeme/privacy',
          component: () => import('@/views/admin/systeme/privacy.vue'),
          meta: { get title() { return translate('perspective.shell.route.privacySettings'); } }
        },
        {
          name: 'admin-systeme-privacy-documents',
          path: 'systeme/privacy/documents',
          component: () => import('@/views/admin/systeme/privacy-documents.vue'),
          meta: { get title() { return translate('perspective.shell.route.privacyDocuments'); } }
        },
        {
          name: 'admin-systeme-privacy-conservation',
          path: 'systeme/privacy/conservation',
          component: () => import('@/views/admin/systeme/privacy-retention.vue'),
          meta: { get title() { return translate('perspective.shell.route.retention'); } }
        },
        {
          name: 'admin-systeme-audit',
          path: 'systeme/audit',
          component: () => import('@/views/admin/systeme/audit.vue'),
          meta: { get title() { return translate('perspective.shell.nav.auditLog'); } }
        }
      ]
    }
];
